import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import { createCPIAdjustmentDateOptions } from '../../lib/CPIHelpers';

export default {
  computed: {
    ...mapState('tenancy', {
      cpi: state => state.CPIAdjustment,
    }),
  },
  methods: {
    ...mapActions('tenancy', ['fetchTenancyCPIAdjustment', 'updateTenancyCPIAdjustment', 'cancelTenancyCPIAdjustment']),

    getPreviousCPIAdjustment(dueDay, startDate) {
      const dates = createCPIAdjustmentDateOptions(startDate, parseInt(dueDay), moment().format('YYYY-MM-DD')).map(
        value => ({
          name: moment(value, 'YYYY-MM-DD').format('YYYY MMMM'),
          value,
        })
      );

      if (!dates.length) {
        throw new Error('cpi.js(getPreviousCPIAdjustment): failed to get date options');
      }
      return moment(dates[0]).subtract(1, 'year').format('YYYY-MM-DD');
    },
    async handleCPIRemoval(landlordId, tenancyId, dueDay, startDate) {
      if (!this.cpi) {
        try {
          await this.fetchTenancyCPIAdjustment({
            landlordId,
            tenancyId,
          });
        } catch {
          throw new Error('cpi.js(handleCPIRemoval): failed fetching cpi adjustment');
        }
      }

      if (this.cpi.status === 'inactive') {
        return;
      }

      const previousCPIAdjustment = this.getPreviousCPIAdjustment(dueDay, startDate);
      const today = moment();
      const isLastCPIInTheFuture = moment(previousCPIAdjustment).isSameOrAfter(today);

      try {
        if (this.cpi.inProgress && !isLastCPIInTheFuture) {
          this.cancelTenancyCPIAdjustment({
            landlordId,
            tenancyId,
          });
        } else {
          this.updateTenancyCPIAdjustment({
            landlordId,
            tenancyId,
            data: {
              status: 'inactive',
              previousCPIAdjustment: previousCPIAdjustment,
            },
          });
        }
      } catch {
        throw new Error('cpi.js(handleCPIRemoval): failed removal/deactivation of CPI adjustment');
      }
    },
  },
};
